import React from 'react';

import { createIcon } from '../createIcon';

function SvgBan(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 2c3.321 0 6 2.679 6 6s-2.679 6-6 6a5.99 5.99 0 01-6-6c0-3.321 2.679-6 6-6zM4.32 4.32a.857.857 0 000 1.213l5.857 6.115a.857.857 0 101.212-1.212L5.533 4.32a.857.857 0 00-1.213 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export const BanFilledIcon = createIcon(SvgBan, 'BanFilledIcon');
